import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import Footer from '../../components/Footer';
import { Header } from '../../components/Header';
import { Card } from './components/Card';

import owlImage from '../../assets/img/pet/corujaProfessora.png';

import { GrCircleInformation } from 'react-icons/gr';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import {
  Container,
  Content,
  Description,
  InstructionsButton,
  ModalContent,
  Tournament,
  TournamentsContainer,
} from './styles';
import Modal from 'antd/lib/modal/Modal';
import { Button } from 'antd';
import { apiPHP } from '../../services/api';
import { TournamentDetail, tournamentItems } from './items';

interface StateLocationProps {
  state: {
    id: number;
  };
}

export const TournamentsList: React.FC = () => {
  const [tournament, setTournament] = useState<TournamentDetail>({});
  const location = useLocation();
  const { state } = location as StateLocationProps;

  const navigate = useNavigate();

  useEffect(() => {
    if (!state || !state.id) {
      navigate('/tournaments');
    }
  }, [navigate, state]);

  const [isInstructionsModalOpen, setIsInstructionsModalOpen] = useState(false);

  useEffect(() => {
    const getTournamentsList = async () => {
      const response = await apiPHP.get(`jogo/edicoes/${state?.id}`);

      setTournament(response.data);
    };
    getTournamentsList();
  }, [state?.id]);

  return (
    <Container>
      <Header />
      <Content>
        <TournamentsContainer>
          <h2>{tournament.nome}</h2>
          <Tournament>
            {tournamentItems(tournament).map((item, index) => (
              <Card
                key={item.key}
                item={item}
                position={index + 1}
                foto={tournament.foto ?? ''}
              />
            ))}
          </Tournament>

          <InstructionsButton onClick={() => setIsInstructionsModalOpen(true)}>
            <GrCircleInformation />
          </InstructionsButton>
        </TournamentsContainer>
        <Description>
          <img src={owlImage} alt="Ilustração Coruja" />

          <strong>Como funciona:</strong>
          <p>Cada card à lista da esquerda representa um jogo</p>
          <p>O primeiro estará desbloqueado e o restante bloqueado</p>
          <p>Ao finalizar um jogo o próximo será desbloqueado</p>
          <p>
            Ou seja, ao finalizar o primeiro jogo, o segundo será desbloqueado
          </p>
          <p>E assim seguirá sucessivamente até o final do torneio</p>
        </Description>
      </Content>
      <Footer />

      <Modal
        visible={isInstructionsModalOpen}
        onCancel={() => setIsInstructionsModalOpen(false)}
        footer={[
          <Button
            type="primary"
            onClick={() => setIsInstructionsModalOpen(false)}
          >
            Entendi
          </Button>,
        ]}
      >
        <ModalContent>
          <strong>Como funciona:</strong>
          <div>
            <p>Cada card da lista representa um jogo</p>
            <p>O primeiro estará desbloqueado e o restante bloqueado</p>
            <p>Ao finalizar um jogo o próximo será desbloqueado</p>
            <p>
              Ou seja, ao finalizar o primeiro jogo, o segundo será desbloqueado
            </p>
            <p>E assim seguirá sucessivamente até o final do torneio</p>
          </div>

          <img src={owlImage} alt="Ilustração Coruja" />
        </ModalContent>
      </Modal>
    </Container>
  );
};
